export enum ServiceFeatures {
	Analytics = 'ent-ph-complex-analytics',
	AssortmentTypes = 'ent-assortment-types',
	Brands = 'ent-brands',
	Categories = 'ent-categories',
	Demo = 'ent-demo-access',
	ExecutionControl = 'ent-ph-execution-control',
	LayoutReverse = 'ent-ph-layout-reverse',
	LayoutRules = 'ent-ph-layout-rules',
	LoadAssortment = 'ent-ph-load-assortment',
	Markers = 'ent-markers',
	MasterPositions = 'ent-master-positions',
	Notifications = 'ent-ph-notifications',
	Onboarding = 'ent-ph-onboarding',
	PlanogramBlocks = 'ent-ph-planogram-blocks',
	PlanogramCopy = 'ent-ph-planogram-copy',
	PlanogramExtendedCopy = 'ent-ph-planogram-extended-copy',
	PlanogramRevert = 'ent-ph-planogram-revert',
	PlanogramsComparison = 'ent-ph-planograms-compare',
	PlanogramsExecution = 'ent-ph-planograms-execution',
	PlansComparison = 'ent-ph-plans-compare',
	ProductPrice = 'ent-product-price',
	ProductsArchive = 'ent-ph-archive-products',
	ProductsHighlight = 'ent-ph-products-highlight',
	ProductsRotation = 'ent-ph-products-rotation',
	ProductStatuses = 'ent-product-statuses',
	ProductStock = 'ent-product-stock',
	Receipts = 'ent-receipts',
	StoreGroups = 'ent-store-groups',
	StoreMarkers = 'ent-store-markers',
	StorePlans = 'ent-ph-store-plans',
	Stores = 'ent-stores',
	Suppliers = 'ent-suppliers',
	Tasks = 'ent-ph-tasks',
	Terminals = 'ent-terminals',
	Welcome = 'ent-ph-welcome'
}